<template>
  <el-table-column
    prop="region"
    label="Régió"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.region || '-' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'region',
  };
</script>
